import React from 'react';

export class Footer extends React.Component{

    constructor(props){
        super(props);

        this.handleRulesOpen = this.handleRulesOpen.bind(this);
    }

    handleRulesOpen(e){
        e.preventDefault();
        this.props.onClick();
    }
    render(){
        return(
            <footer id="bottombar" className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <img src="./assets/avainlippu.1d87e98d98563255c988020a408f7c37.png" alt="avainlippu logo" className="avainlippu" />
                        </div>
                        <div className="col-sm-6">
                            <p className="top-rules"><a href="#"  onClick={ this.handleRulesOpen }>Palkinnot ja säännöt <i className="fa fa-angle-right" aria-hidden="true"></i></a></p>
                        </div>
                    </div>
            </footer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Footer.js